import { EQUAL, EMPTY_STR, AMPERSAND } from '@lacele/const'

const internalMakeQueryParam = (propName, propValue) => {
    if (propValue === undefined || propValue === null) {
        return encodeURIComponent(propName)
    }
    return encodeURIComponent(propName) + EQUAL + encodeURIComponent(propValue)
}

export default (propName, propValue) => {
    if (Array.isArray(propValue)) {
        return propValue.reduce((prevValue, currPropValue, index) => {
            const currValue = internalMakeQueryParam(propName, currPropValue)
            if (index === 0) {
                return currValue
            }
            return prevValue + AMPERSAND + currValue
        }, EMPTY_STR)
    }
    return internalMakeQueryParam(propName, propValue)
}
